module.exports = __webpack_public_path__ + "88117db126727c8d0e2f9b0bcc8187c4.MP3";